var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-btn',{attrs:{"color":"blue darken-2","loading":_vm.loading,"text":_vm.$t('common.reload'),"icon":"mdi-reload"},on:{"press":_vm.press}})}
var staticRenderFns = []

export { render, staticRenderFns }